import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import BackgroundReduceSmokingForm from './BackgroundReduceSmokingForm'
import BackgroundOfRiskPointsView from './BackgroundReduceSmokingView'
import { useForm, Controller } from 'react-hook-form'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { startLoading, doneLoading } from '../../../../utils/loading'
import { getSchemaSidebar } from '../../../../redux/actions/sidebar'
import { updateForm7, saveForm7 } from '../../../../redux/actions/background'
import ButtonPanel from '../../../ButtonPanel'
import WhisperMoreContent from '../../../WhisperMoreContent'
import WarningMessage from '../../../../components/message/WarningMessage/WarningMessage'

export default function BackgroundReduceSmokingWidget(props) {
  const { showCommandButton, schema, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(schema)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [moreContent, setMoreContent] = useState(true)
  const [moreContentBottom, setMoreContentBottom] = useState(true)

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        console.log('call update.')
        response = await updateForm7(projectId, request)
      } else {
        console.log('call save.')
        response = await saveForm7(projectId, request)
      }
      console.log('response', response)
      if (response) {
        onChangeIsEdit(false)
        setFormSchema(response)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      generalInfo: data.generalInfo || '-ไม่ระบุ-',
      environment: data.environment,
      nonSmokingPlace: data.nonSmokingPlace || 0,
      nonSmokingPlaceDetail: data.nonSmokingPlaceDetail,
      tobaccoCigarette: data.tobaccoCigarette,
      smokingProblemVillage: data.smokingProblemVillage,
      allHousehold: data.allHousehold || 0,
      allHouseholdSmoking: data.allHouseholdSmoking || 0,
      smokerMale: data.smokerMale || 0,
      noneSmokerMale: data.noneSmokerMale || 0,
      smokerFemale: data.smokerFemale || 0,
      noneSmokerFemale: data.noneSmokerFemale || 0,
      problemOfSmoking: data.problemOfSmoking || [],
      sickOfSmoking: data.sickOfSmoking,
      sickOfCigaretteSmoke: data.sickOfCigaretteSmoke,
      costProblem: data.costProblem,
      controlCigarette: data.controlCigarette,
      howControlCigarette: data.howControlCigarette,
      resultControlCigarette: data.resultControlCigarette,
      obstacleControlCigarette: data.obstacleControlCigarette,
      village: data.village,
      province: data.province,
      district: data.district,
      subDistrict: data.subDistrict,
      shopInfo: data.shopInfo,
    }

    console.log('request', request)
    handleCallService(request)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {moreContent && (
        <>
          <div dangerouslySetInnerHTML={{ __html: formSchema.introduction }} />
        </>
      )}

      {formSchema.introduction && (
        <div style={{ textAlign: 'center', marginTop: '10px' }}>
          <WhisperMoreContent
            isShow={moreContent}
            onClick={() => {
              setMoreContent(!moreContent)
            }}
          />
        </div>
      )}

      {isEdit && showCommandButton ? (
        <BackgroundReduceSmokingForm
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          getValues={getValues}
        />
      ) : (
        <BackgroundOfRiskPointsView schema={formSchema} />
      )}

      {formSchema.footer && (
        <div style={{ textAlign: 'center' }}>
          <WhisperMoreContent
            isShow={moreContentBottom}
            onClick={() => {
              setMoreContentBottom(!moreContentBottom)
            }}
          />
        </div>
      )}

      {moreContentBottom && (
        <div
          dangerouslySetInnerHTML={{
            __html: formSchema.footer,
          }}
        />
      )}

      {showCommandButton && (
        <>
          <hr />
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || 'ความเป็นมาหลักการและเหตุผล'}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </>
      )}
    </Panel>
  )
}

//  const formSchemas = {
//     header: 'ความเป็นมา/ หลักการและเหตุผล/ ความสำคัญของปัญหา (07 ลด ละ เลิกบุหรี่ ปี 63)',
//     introduction: `<p>
//     &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; อัตราการสูบบุหรี่ของประชาชนอายุ 15 ปีขึ้นไปในปี
//     พ.ศ. 2558 คิดเป็นร้อยละ 19.9
//     ซึ่งกระทรวงสาธารณสุขประกาศเป้าหมายการลดอัตราการสูบบุหรี่ให้เหลือร้อยละ 15.0 ในปี พ.ศ. 2568
//     เพื่อลดพฤติกรรมเสี่ยงที่เกี่ยวเนื่องกับการเจ็บป่วยโรคไม่ติดต่อเรื้อรัง ได้แก่
//     โรคถุงลมโป่งพอง หัวใจขาดเลือด หลอดเลือดสมองตีบ
//     พร้อมกันนี้แผนยุทธศาสตร์เพื่อการควบคุมยาสูบแห่งชาติได้กำหนดยุทธศาสตร์การควบคุมยาสูบให้มีประสิทธิภาพนั้น
//     จำเป็นอย่างยิ่งที่จะดำเนินการใน 5 ยุทธศาสตร์หลัก ได้แก่ 1) การป้องกันนักสูบหน้าใหม่ 2)
//     บริการช่วยเลิกยาสูบ 3) สร้างสิ่งแวดล้อมปลอดบุหรี่ 4)
//     เสริมสร้างความเข้มแข็งและพัฒนาขีดความสามารถในการดำเนินการควบคุมยาสูบ และ 5)
//     การเฝ้าระวังและบังคับใช้กฎหมาย
//   </p>
//   <p>
//     &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ปัญหาการสูบบุหรี่ของคนไทยพบว่า
//     ยังคงเป็นปัญหาอยู่ในพื้นที่นอกเขตเทศบาล/ในชนบทที่ประชาชนยังขาดความรู้และความตระหนักต่อปัญหาการสูบบุหรี่ที่มีผลกระทบต่อสุขภาพของผู้สูบบุหรี่โดยตรง
//     อีกทั้งสิ่งแวดล้อมที่ยังเอื้อให้เข้าถึงบุหรี่ได้ง่าย เช่น
//     ร้านค้ายังจำหน่ายบุหรี่ให้เด็กอายุต่ำกว่า 20 ปี มีการขายบุหรี่แยกซอง
//     และเกิดการเจ็บป่วยอันเนื่องมาจากการสูบบุหรี่
//     การได้รับควันบุหรี่มือสองและมือสามทำให้เป็นภาระทางเศรษฐกิจแก่บุคคลและครอบครัว
//     อีกทั้งค่าใช้จ่ายการสูบบุหรี่ที่สูงขึ้นโดยเฉพาะอย่างยิ่งการสูบบุหรี่โรงงานที่อัตราภาษีเพิ่มสูงขึ้นทำให้บุหรี่มีราคาสูงขึ้น
//   </p>
//   <p>
//     &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
//     ปัจจุบันประเทศไทยมีพระราชบัญญัติควบคุมผลิตภัณฑ์ยาสูบ พ.ศ. 2560
//     ซึ่งมีสาระทางกฎหมายที่เคร่งครัดและรุนแรงมากขึ้นต่อการกระทำผิดในการละเมิดการจำหน่ายและการสูบในสถานที่ห้ามสูบ
//     อย่างไรก็ดีปัญหาการบังคับใช้กฎหมายยังคงเป็นปัญหาที่แก้ไขได้ยากโดยเฉพาะอย่างยิ่งในชุมชนชนบทที่มีบริบททางสังคมวัฒนธรรมและมีความสัมพันธ์ฉันท์เครือญาติของคนในชุมชน
//   </p>`,
//     finalText: `ได้เล็งเห็นความสำคัญของปัญหาการสูบบุหรี่/ยาสูบในชุมชน จึงได้จัดทำโครงการลด ละ
//     เลิกบุหรี่/ยาสูบ โดยใช้ชุมชนเป็นฐาน
//     เพื่อปรับเปลี่ยนพฤติกรรมการสูบบุหรี่/ยาสูบคนในชุมชน เพื่อเป้าหมายการมีสุขภาพดี
//     และลดการเจ็บป่วยด้วยโรคเรื้อรังได้ในอนาคต`,

//     generalInfo: {
//       name: 'generalInfo',
//       label: 'ข้อมูลทั่วไป',
//       description: ['เขียนอธิบายให้ครอบคลุมจำนวนครัวเรือน จำนวนประชากร อาชีพ เศรษฐกิจ'],
//       value: '',
//     },
//     environment: {
//       name: 'environment',
//       label: 'ข้อมูลสภาพแวดล้อมที่เกี่ยวข้อง',
//       description: [
//         'เขียนอธิบายให้ครอบคลุมเรื่องร้านค้าที่จำหน่ายบุหรี่/ยาสูบในชุมชน เช่น มีกี่ร้านมีการจำหน่ายบุหรี่ให้เด็ก มีการขายเป็นมวน) สถานที่ที่ต้องปลอดบุหรี่ตามกฎหมายมีกี่แห่งและมีการจัดเป็นเขตปลอดบุหรี่หรือไม่ (มีสติ๊กเกอร์ติด)',
//       ],
//       value: '',
//     },

//     shopInfo: {
//       name: 'shopInfo',
//       label: 'ข้อมูลร้านค้า จำแนกตามข้อปฏิบัติของ พรบ.ยาสูบ พ.ศ. 2560',
//       description: ['ให้เติมข้อมูลการสำรวจร้านค้าในชุมชนทุกร้าน โดยบันทึก “ทำ/ไม่ทำ” ในตาราง'],
//       value: [
//         {
//           act: {
//             id: '1',
//             act: 'ห้ามขายหรือให้ผลิตภัณฑ์ยาสูบแก่บุคคลที่มีอายุต่ำกว่า 20 ปี',
//           },
//           shops: [true, false, true],
//         },
//         {
//           act: {
//             id: '2',
//             act: 'ห้ามให้บุคคลที่มีอายุต่ำกว่า 18 ปี เป็นผู้ขายผลิตภัณฑ์ยาสูบ',
//           },
//           shops: [true, , false],
//         },
//         {
//           act: {
//             id: '3',
//             act: 'ห้ามแบ่งซองขายบุหรี่เป็นรายมวน',
//           },
//           shops: [true, true, true],
//         },
//         {
//           act: {
//             id: '4',
//             act: 'อื่นๆ เช่น การติดป้ายโฆษณาเชิญชวนให้ขายบุหรี่',
//           },
//           shops: [false, false, true],
//         },
//       ],
//       acts: [
//         {
//           id: '1',
//           act: 'ห้ามขายหรือให้ผลิตภัณฑ์ยาสูบแก่บุคคลที่มีอายุต่ำกว่า 20 ปี',
//         },
//         {
//           id: '2',
//           act: 'ห้ามให้บุคคลที่มีอายุต่ำกว่า 18 ปี เป็นผู้ขายผลิตภัณฑ์ยาสูบ',
//         },
//         {
//           id: '3',
//           act: 'ห้ามแบ่งซองขายบุหรี่เป็นรายมวน',
//         },
//         {
//           id: '4',
//           act: 'อื่นๆ เช่น การติดป้ายโฆษณาเชิญชวนให้ขายบุหรี่',
//         },
//       ],
//     },

//     nonSmokingPlace: {
//       name: 'nonSmokingPlace',
//       label: 'สถานที่ปลอดบุหรี่ในชุมชน',
//       preLabel: 'จำนวน',
//       postLabel: 'แห่ง',
//       value: '',
//     },
//     nonSmokingPlaceDetail: {
//       name: 'nonSmokingPlaceDetail',
//       label: 'ได้แก่',
//       value: '',
//     },

//     tobaccoCigarette: {
//       name: 'tobaccoCigarette',
//       label: 'สถานการณ์บุหรี่/ยาสูบของประชากรในจังหวัด',
//       description: [
//         'ให้ระบุข้อมูลสถานการณ์บุหรี่/ยาสูบของประชากรในจังหวัดตนเอง เพื่อให้ทราบถึงสถานการณ์การสูบบุหรี่ในจังหวัดเปรียบเทียบกับระดับประเทศ โดยสามารถใช้ข้อมูลจากรายงานสถิติการบริโภคยาสูบของประเทศไทย พ.ศ.2561 โดยศูนย์วิจัยและจัดการความรู้เพื่อการควบคุมยาสูบ มหาวิทยาลัยมหิดล (ศจย.) (ดูข้อมูลได้ที่ภาคผนวก อัตราการบริโภคยาสูบรายจังหวัด)',
//       ],
//       value: '',
//     },
//     smokingProblem: {
//       label: 'สถานการณ์ปัญหาการสูบบุหรี่ในพื้นที่',
//       description: [
//         'โปรดระบุแหล่งที่มาของข้อมูล เช่น รพ.สต., จากการสัมภาษณ์..ระบุชื่อ และตำแหน่งผู้ให้ข้อมูล, ปีที่เก็บข้อมูล',
//       ],
//     },
//     smokingProblemView: {
//       label1: 'จากการสำรวจข้อมูลเบื้องต้นของหมู่บ้าน',
//       label2: 'เกี่ยวกับพฤติกรรมการสูบบุหรี่/ยาสูบ พบข้อมูลตามตารางดังนี้',
//       label3:
//         'ตารางที่ 1 แสดงร้อยละและจำนวนผู้สูบบุหรี่และพฤติกรรมการสูบบุหรี่/ยาสูบ ในปี พ.ศ. 2561',
//       label4: 'ปี 2561',
//     },
//     smokingProblemVillage: {
//       name: 'smokingProblemVillage',
//       label: 'หมู่บ้าน ',
//       value: '',
//     },
//     householdSmoking: {
//       label: '1. จำนวนครัวเรือนบริโภคบุหรี่/ยาสูบ',
//     },
//     allHousehold: {
//       name: 'allHousehold',
//       label: 'จำนวนครัวเรือนทั้งหมดในหมู่บ้าน (ที่อาศัยอยู่จริง) :',
//       preLabel: 'จำนวน',
//       postLabel: 'ครัวเรือน',
//       value: '',
//     },
//     allHouseholdSmoking: {
//       name: 'allHouseholdSmoking',
//       label: 'จำนวนครัวเรือนที่พบพฤติกรรมการสูบบุหรี่/ยาสูบ :',
//       preLabel: 'จำนวน',
//       postLabel: 'ครัวเรือน',
//       value: '',
//     },

//     smoker: {
//       label: '2. จำนวนผู้สูบบุหรี่/ยาสูบในชุมชน (จำแนกตามเพศ)',
//       description: ['ให้นับจำนวนผู้สูบบุหรี่ทุกคนที่สูบบุหรี่ แม้เพียงมวนเดียว'],
//     },
//     smokerMale: {
//       name: 'smokerMale',
//       label: 'เพศชาย :',
//       preLabel: 'สูบบุหรี่',
//       postLabel: 'คน',
//       value: '',
//     },
//     noneSmokerMale: {
//       name: 'noneSmokerMale',
//       preLabel: 'ไม่สูบบุหรี่',
//       postLabel: 'คน',
//       value: '',
//     },
//     smokerFemale: {
//       name: 'smokerFemale',
//       label: 'เพศหญิง :',
//       preLabel: 'สูบบุหรี่',
//       postLabel: 'คน',
//       value: '',
//     },
//     noneSmokerFemale: {
//       name: 'noneSmokerFemale',
//       preLabel: 'ไม่สูบบุหรี่',
//       postLabel: 'คน',
//       value: '',
//     },
//     problemOfSmoking: {
//       name: 'problemOfSmoking',
//       label: 'ปัญหาต่างๆ ที่เกิดจากการสูบบุหรี่/ยาสูบ',
//       description: ['ระบุเฉพาะข้อมูลที่พบในชุมชนเท่านั้น'],
//       value: [],
//     },
//     sickOfSmoking: {
//       name: 'sickOfSmoking',
//       preLabel:
//         'ความเจ็บป่วยเนื่องจากการบริโภคบุหรี่/ยาสูบ (เช่น ผู้ป่วยโรคเรื้อรังที่มีการบริโภคบุหรี่/ยาสูบ ให้อธิบายข้อมูลการเจ็บป่วยและความรุนแรงที่เกิดขึ้น)',
//       value: '',
//     },
//     sickOfCigaretteSmoke: {
//       name: 'sickOfCigaretteSmoke',
//       preLabel:
//         'ความเจ็บป่วยเนื่องจากการได้รับควันบุหรี่มือสองและมือสาม (เช่น เด็กป่วยเป็นหืดหอบ ให้อธิบายข้อมูลการเจ็บป่วยและความรุนแรงที่เกิดขึ้น)',
//       value: '',
//     },
//     costProblem: {
//       name: 'costProblem',
//       preLabel:
//         'มีปัญหาค่าใช้จ่าย (ให้อธิบายข้อมูลประกอบ เช่น จำนวนเงินค่าใช้จ่ายบุหรี่/ยาสูบในครอบครัว)',
//       value: '',
//     },

//     controlCigarette: {
//       name: 'controlCigarette',
//       label: 'ในปีที่ผ่านมาชุมชนของท่านเคยดำเนินการในการควบคุมบุหรี่/ยาสูบหรือไม่',
//       value: '1',
//       options: [
//         { value: 1, label: 'เคย' },
//         { value: 0, label: 'ไม่เคย' },
//       ],
//     },

//     howControlCigarette: {
//       name: 'howControlCigarette',
//       label: 'วิธีดำเนินการในการควบคุมบุหรี่/ยาสูบ',
//       value: '',
//     },
//     resultControlCigarette: {
//       name: 'resultControlCigarette',
//       label: 'ผลที่เกิดขึ้น (โปรดระบุ)',
//       value: '',
//     },
//     obstacleControlCigarette: {
//       name: 'obstacleControlCigarette',
//       label: 'ปัญหาอุปสรรค',
//       value: '',
//     },

//     village: {
//       name: 'village',
//       label: 'ด้วยเหตุนี้ทางหมู่บ้าน/ชุมชน',
//       value: '',
//     },
//     province: {
//       name: 'province',
//       label: 'จังหวัด',
//       value: '',
//     },
//     district: {
//       name: 'district',
//       label: 'อำเภอ',
//       value: '',
//     },
//     subDistrict: {
//       name: 'subDistrict',
//       label: 'ตำบล',
//       value: '',
//     },
//   }
